var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 68,
    viewBox: "0 0 70 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.4075 9.94949C45.9483 -3.31596 24.0504 -3.31596 10.5938 9.94628C-2.86546 23.2085 -2.86416 44.7897 10.5951 58.0545C24.0504 71.3161 45.9483 71.3161 59.4062 58.052C72.8642 44.7897 72.8635 23.2098 59.4075 9.94949ZM55.6413 54.3429C44.26 65.5592 25.7406 65.5605 14.3587 54.3442C2.97481 43.1259 2.97611 24.873 14.3587 13.6566C25.7399 2.44095 44.2587 2.43967 55.6426 13.6579C67.0239 24.8742 67.0226 43.1272 55.6413 54.3429ZM50.6058 47.446C51.0339 48.4212 50.5785 49.5528 49.5896 49.9741C48.6001 50.3972 47.4518 49.9471 47.0237 48.9726C45.1416 44.6839 40.6936 41.9122 35.6899 41.9122C30.5712 41.9122 26.0958 44.6814 24.2905 48.9675C23.9788 49.7074 23.2521 50.1542 22.4877 50.1542C22.2379 50.1542 21.9848 50.1068 21.7395 50.0068C20.7441 49.599 20.2725 48.4731 20.6856 47.4928C23.0992 41.766 28.9896 38.0659 35.6899 38.0659C42.2504 38.0659 48.1056 41.7474 50.6058 47.446ZM22.1253 24.7941C22.1253 22.5988 23.932 20.8183 26.1596 20.8183C28.3865 20.8183 30.1932 22.5981 30.1932 24.7941C30.1932 26.9907 28.3865 28.7705 26.1596 28.7705C23.932 28.7705 22.1253 26.9907 22.1253 24.7941ZM40.4177 24.7941C40.4177 22.5988 42.2257 20.8183 44.4533 20.8183C46.6802 20.8183 48.4869 22.5981 48.4869 24.7941C48.4869 26.9907 46.6809 28.7705 44.4533 28.7705C42.2257 28.7705 40.4177 26.9907 40.4177 24.7941Z",
    fill: "url(#paint0_linear_43637_13843)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_43637_13843",
    x1: 35.6019,
    y1: -9.73906,
    x2: 35.6019,
    y2: 73.6492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08538C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#6F5BA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F5648B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF8A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC038"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.f9388daf032283b592301cda7d62fd1e.svg";
export { ForwardRef as ReactComponent };